import { stockBalanceService } from '../../helpers/services/stockBalance.service'
import { sharedHelper } from '@/utils'

export const state = {
  list: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  byItem: [],
  status: { list: true, detail: true },
}

export const STOCK_BALANCE_MODULE = 'stockBalance'

export const GET_ALL_STOCK_BALANCES = 'getAllStockBalances'
export const GET_STOCK_BALANCE_BY_ITEM = 'getStockBalanceByItem'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const BY_ITEM_SUCCESS = 'byItemSuccess'

function mapRow(item) {
  return {
    itemCode: item.item_code,
    location: item.location,
    uom: item.uom,
    balanceQty: Number(item.balance_qty) || 0,
    balanceCost: Number(item.balance_cost) || 0,
    totalValue: (Number(item.balance_qty) || 0) * (Number(item.balance_cost) || 0),
  }
}

export const actions = {
  [GET_ALL_STOCK_BALANCES]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    stockBalanceService.getAllStockBalances(filter).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_STOCK_BALANCE_BY_ITEM]({ commit }, { itemCode }) {
    commit(REQUESTING, 'detail')
    return stockBalanceService.getStockBalanceByItem(itemCode).then((r) => {
      commit(BY_ITEM_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [BY_ITEM_SUCCESS](state, data) {
    state.byItem = (data.data || []).map(mapRow)
  },
  [FAILURE](state) { state.status = { list: true, detail: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, detail: true } },
}
